<div class="other-assumptions">
  <klt-other-compare
    (onSelect)="onSelectScenarios($event)"
    (buttonClick)="openDialog()"
  ></klt-other-compare>
  <klt-other-table [updatedData]="tableData"></klt-other-table>
</div>
